module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_9.4a9c5ed0.png";